module.exports = __webpack_public_path__ + "img/ijece-nlogo.197108b2.png";